import { AlternativeEditorDialogViewModel } from '@Alternatives/Alternatives/Components/AlternativeEditorDialog';
import AlternativeEditorDialog from '@Alternatives/Alternatives/Components/AlternativeEditorDialog.vue';
import { UpdateAlternativeCommandV1 } from "@Alternatives/Alternatives/Domain/commands-core";
import AlternativesQueries from "@Alternatives/Alternatives/Domain/queries-vue-component";
import { AlternativeAttributeValueReadModel, AlternativeReadModel, AlternativesReadModel } from "@Alternatives/Alternatives/Domain/readmodels";
import { AlternativesComparisonDialogViewModel } from '@Alternatives/AlternativesLists/Components/AlternativesComparisonDialog';
import AlternativesComparisonDialog from "@Alternatives/AlternativesLists/Components/AlternativesComparisonDialog.vue";
import { UpdateMultipleAlternativesAttributeValueCommandV1, UpdateMultipleAlternativesStatusCommandV1 } from "@Alternatives/AlternativesLists/Domain/commands-core";
import AlternativesListsCommands from "@Alternatives/AlternativesLists/Domain/commands-vue-component";
import AlternativesListsQueries from '@Alternatives/AlternativesLists/Domain/queries-vue-component';
import { AlternativesComparisonReadModel } from '@Alternatives/AlternativesLists/Domain/readmodels';
import { StaticViewBuilderViewModel } from '@Alternatives/AlternativesViews/Components/StaticViewBuilder';
import StaticViewBuilder from '@Alternatives/AlternativesViews/Components/StaticViewBuilder.vue';
import { AddAlternativesToStaticViewCommandV1, CreateStaticViewCommandV1, RemoveAlternativesFromStaticViewCommandV1 } from "@Alternatives/AlternativesViews/Domain/commands-core";
import AlternativesViewsCommands from "@Alternatives/AlternativesViews/Domain/commands-vue-component";
import AlternativesViewsQueries from "@Alternatives/AlternativesViews/Domain/queries-vue-component";
import { AlternativesViewReadModel } from "@Alternatives/AlternativesViews/Domain/readmodels";
import { AttributeReadModel } from "@Alternatives/Attributes/Domain/readmodels";
import { AttributeUtils } from "@Alternatives/Attributes/utils";
import { FormReadModel } from "@Alternatives/Forms/Domain/readmodels";
import { AlternativeStatusReadModel } from "@Alternatives/Statuses/Domain/readmodels";
import { GetVhPixels, arrayMove, average, ellipsis, getDistinctBgCss, getDistinctColor, isNullOrWhitespace, numCompare, strCompare, strCompareLowerCase } from '@common/Common';
import { ListSelectionDialogViewModel } from '@common/Components/ListSelectionDialog';
import ListSelectionDialog from "@common/Components/ListSelectionDialog.vue";
import { NumericInputDialogViewModel } from '@common/Components/NumericInputDialog';
import NumericInputDialog from "@common/Components/NumericInputDialog.vue";
import PortfolioOrDecisionNavigation from '@common/Components/PortfolioOrDecisionNavigation.vue';
import { guid } from "@common/Guid";
import { ICommandStatus } from '@cqrs/cqrs';
import { KendoChart, KendoChartDataSerie, KendoChartOptions } from '@Kendo/Components/KendoChart';
import KendoChartFullScreenDialog from "@Kendo/Components/KendoChartFullScreenDialog.vue";
import { KendoGrid, KendoGridField, KendoGridOptions, KendoGridRow } from "@Kendo/Components/KendoGrid";
import KendoGridColumnsEditorDialog from "@Kendo/Components/KendoGridColumnsEditorDialog.vue";
import { ICommandBase } from "@Reports/cqrs";
import { ChartOptions, MetricOptions, PortfolioBalancerReportSettings } from '@Reports/Model';
import { ReportEditorData, ReportEditorViewModel } from '@Reports/Reports/Components/ReportEditor';
import ReportEditor from '@Reports/Reports/Components/ReportEditor.vue';
import { UpdatePortfolioBalancerReportCommandV1, UpdateReportCommandV1 } from '@Reports/Reports/Domain/commands-core';
import ReportsCommands from "@Reports/Reports/Domain/commands-vue-component";
import ReportsQueries from '@Reports/Reports/Domain/queries-vue-component';
import { PortfolioBalancerReportReadModel, ReportReadModel } from '@Reports/Reports/Domain/readmodels';
import $ from 'jquery';
import { nextTick } from 'vue';
import { Component, mixins } from 'vue-facing-decorator';

@Component({
    components: {
        PortfolioOrDecisionNavigation, KendoGridColumnsEditorDialog, KendoChartFullScreenDialog, ReportEditor,
        AlternativesComparisonDialog, AlternativeEditorDialog, ListSelectionDialog, NumericInputDialog, StaticViewBuilder
    },
    watch: {
        GroupByAttribute: 'onGroupByAttributeChanged',
        SelectedList: 'onSelectedListChanged'
    }
})
export default class PortfolioBalancerReportPage extends mixins(ReportsQueries, ReportsCommands, AlternativesQueries, AlternativesViewsCommands, AlternativesViewsQueries, AlternativesListsQueries, AlternativesListsCommands)
{
    get workspaceId(): number { return Number(this.$route?.params?.workspaceId ?? 0); }
    get projectId(): number { return Number(this.$route?.params?.projectId ?? 0); }
    get reportId(): string { return this.$route?.params?.reportId ?? ''; }

    rm: PortfolioBalancerReportReadModel = null;
    initialized: boolean = false;
    statusListSelectionDialog: ListSelectionDialogViewModel = new ListSelectionDialogViewModel();
    attrListSelectionDialog: ListSelectionDialogViewModel = new ListSelectionDialogViewModel();
    numericInputDialog: NumericInputDialogViewModel = new NumericInputDialogViewModel();
    kendoGridColumnsEditorDialogOpened: boolean = false;
    fullScreenChart: ChartVM = null;
    alternativesComparisonDialog: AlternativesComparisonDialogViewModel = new AlternativesComparisonDialogViewModel();
    alternativeEditorDialog = new AlternativeEditorDialogViewModel();
    staticViewBuilder: StaticViewBuilderViewModel = new StaticViewBuilderViewModel();
    reportEditor: ReportEditorViewModel = new ReportEditorViewModel();

    StatusShapes: string[] = ['none', 'circle', 'square', 'triangle', 'cross'];
    MetricTypes: string[] = ['Total', 'Avg', 'Min', 'Max'];
    Currencies: string[] = ['USD', 'GBP', 'EUR', 'JPY', 'AUD', 'CAD', 'BRL'].sort((a, b) => strCompare(a, b));
    DecimalsOptions: number[] = [0, 1, 2, 3, 4];

    get NumericAttributes(): AttributeReadModel[] { return this.rm.Attributes.filter(a => a.IsNumeric); }
    get TextAttributes(): AttributeReadModel[] { return this.rm.Attributes.filter(a => a.IsText); }

    BulkEditableAttributesBySection: any[] = [];    

    grid: KendoGrid = null;
    GroupByAttribute: AttributeReadModel = null;
    SelectedList: AlternativesViewReadModel = null;
    Form: FormReadModel = null;
    Alternatives: AlternativeViewModel[] = [];
    SelectedAlternatives: AlternativeViewModel[] = [];

    AlternativesGroups: AlternativesGroup[] = [];
    Metrics: MetricVM[] = [];
    Charts: ChartVM[] = [];

    get MaxChartOrderValue(): number
    {
        //replace with length?
        if (this.Charts.length === 0) { return 0; }
        return Math.max(...this.Charts.map(a => a.OrderValue));
    }
    get ChartsView(): ChartVM[] { return this.Charts.sort((a, b) => numCompare(a.OrderValue, b.OrderValue)); }
    get StaticLists(): AlternativesViewReadModel[] { return this.rm.Lists.filter(a => a.IsStatic); }
    get IsStaticList(): boolean { return this.SelectedList?.IsStatic; }

    Highlight: (e: kendo.dataviz.ui.ChartSeriesHoverEvent) => void = null;
    OnSeriesClick: (e: kendo.dataviz.ui.ChartSeriesClickEvent) => void = null;

    //watcher: GroupByAttribute
    onGroupByAttributeChanged(val: AttributeReadModel | null, oldVal: AttributeReadModel | null)
    {
        if (this.initialized)
        {
            this.BuildAlternativesGroups();
            this.grid.RenderProgressBars();
            this.Charts.forEach(ch => ch.SetData());
        }
    }

    //watcher: SelectedList)
    onSelectedListChanged(val: AlternativesViewReadModel | null, oldVal: AlternativesViewReadModel | null)
    {
        if (this.initialized)
        {
            this.Alternatives = [];
            this.runAlternativesByViewDefIdQueryV1(this.workspaceId, this.projectId, this.SelectedList?.Id);
        }
    }


    showAlternativeEditor(alternativeId: string)
    {
        this.ResetHighlight();
        this.alternativeEditorDialog.showEditor(this.workspaceId, this.projectId, this.rm.AlternativesListId, alternativeId, this.Form?.Id, this.rm.AlternativeLabel);
    }

    showReportEditor()
    {
        this.reportEditor.show({ Id: this.reportId, Name: this.rm.Report.Name, Description: this.rm.Report.Description });
    }

    showGridColumnsEditor()
    {
        if (this.rm.Readonly === false)
        {
            this.kendoGridColumnsEditorDialogOpened = true;
        }
    }


    showStaticViewBuilder()
    {
        if (this.SelectedAlternatives.length > 0)
        {
            this.staticViewBuilder.show(this.SelectedAlternatives.map(a => a.AlternativeId));
        }
    }

    showBulkStatusEditor()
    {
        this.statusListSelectionDialog.valueRequired = true;
        const items = this.rm.Statuses.map(a => { return { key: a.Id.toString(), value: a.Id.toString(), label: a.Name, description: null } });
        this.statusListSelectionDialog.show(null, items);
    }

    showBulkAttributeValueEditor(attr: AttributeReadModel)
    {
        if (attr.IsList)
        {
            this.attrListSelectionDialog.valueRequired = false;
            const items = attr.DefinedValues.map(a => { return { key: a.Value.toString(), value: a.Value.toString(), label: a.Name, description: a.Description } });
            this.attrListSelectionDialog.show(attr.Id.toString(), items);
        }
        else
        {
            this.numericInputDialog.id = attr.Id.toString();
            this.numericInputDialog.valueRequired = true;
            this.numericInputDialog.label = attr.Name;
            this.numericInputDialog.description = attr.Description;
            this.numericInputDialog.minValue = attr.MinValue != null ? Number(attr.MinValue) : null;
            this.numericInputDialog.maxValue = attr.MaxValue != null ? Number(attr.MaxValue) : null;
            this.numericInputDialog.show();
        }
    }

    showAlternativesComparison()
    {
        const viewDefId = this.SelectedList?.Id ?? null;
        const formId = this.Form?.Id ?? null;

        this.alternativesComparisonDialog.show();
        this.runAlternativesComparisonQueryV1(this.workspaceId, this.projectId, viewDefId, this.SelectedAlternatives.map(a => a.Id), formId);
    }


    ResetHighlight()
    {
        this.Charts
            .filter(a => (a.Type === 'scatter' || a.Type === 'bubble') && a.Chart != null)
            .forEach(chart =>
            {
                chart.Chart.ToggleHighlight(false, () => true);
                chart.Chart.HideTooltip();
            });
    }

    BuildAlternativesGroups()
    {
        //new alternatives
        //new attribute
        //new attr values (update)

        if (this.GroupByAttribute == null)
        {
            const color = getDistinctColor(0);
            const bgColor = getDistinctBgCss(0);

            this.Alternatives.forEach(a =>
            {
                a.Color = color;
                a.BgColor = bgColor;
                a.Group = "Total";
            });

            this.AlternativesGroups = [new AlternativesGroup("Total", color, bgColor)];
        }
        else
        {
            const attrId = this.GroupByAttribute.Id;

            const uniqueValues = this.Alternatives
                .flatMap(a => a.AttributeValues)
                .filter(a => a.AttributeId === attrId)
                .map(a => a.Value as string)
                .filter(a => !isNullOrWhitespace(a))
                .filter((v, index, names) => names.indexOf(v) === index)
                .sort((a, b) => strCompareLowerCase(a, b));

            const arr: AlternativesGroup[] = [];

            for (let i = 0; i < uniqueValues.length; i++)
            {
                const val = uniqueValues[i];
                const color = getDistinctColor(i);
                const bgColor = getDistinctBgCss(i);

                const alternatives = this.Alternatives.filter(a => a.AttributeValues.some(av => av.AttributeId === attrId && av.Value as string === val));

                alternatives.forEach(a =>
                {
                    a.Color = color;
                    a.BgColor = bgColor;
                    a.Group = val;
                });

                arr.push(new AlternativesGroup(val, color, bgColor));
            }

            const notSet = this.Alternatives.filter(a => !a.AttributeValues.some(av => av.AttributeId === attrId && !isNullOrWhitespace(av.Value as string)));

            if (notSet.length > 0)
            {
                const color = getDistinctColor(uniqueValues.length);
                const bgColor = getDistinctBgCss(uniqueValues.length);

                notSet.forEach(a =>
                {
                    a.Color = color;
                    a.BgColor = bgColor;
                    a.Group = null;
                });

                arr.push(new AlternativesGroup(null, color, bgColor));
            }

            this.AlternativesGroups = arr;
        }
    }


    renderGrid(gridJsonOptions: string)
    {
        let fields = [
            new KendoGridField(FieldId.Id, "string", false, null),
            new KendoGridField(FieldId.AlternativeId, "number", false, null),
            new KendoGridField(FieldId.AlternativeName, "string", true, "Name", null, ""),
            new KendoGridField(FieldId.AlternativeDescription, "string", true, "Description", null, ""),
            new KendoGridField(FieldId.AlternativeCreated, "date", true, "Created", "{0:g}", ""),
            new KendoGridField(FieldId.AlternativeModified, "date", true, "Modified", "{0:g}", ""),
            new KendoGridField(FieldId.AlternativeStatusName, "string", true, "Status", null, ""),
            new KendoGridField(FieldId.AlternativeStartDate, "date", true, "Start date", "{0:MMMM, yyyy}", ""),
            new KendoGridField(FieldId.AlternativeCommitmentDate, "date", true, "Commitment", "{0:MMMM, yyyy}", ""),
        ];

        // Extend predefined fields with dynamic attribute-based fields
        fields = fields.concat(this.rm.Attributes.map(attr =>
            new KendoGridField(FieldId.Attribute(attr.Id), AttributeUtils.getGridFieldType(attr), true, attr.Name, attr.Format, attr.Section)
        ));

        let columns: kendo.ui.GridColumn[] = [];

        const savedColumns = KendoGrid.GetSavedColumns(gridJsonOptions);

        if (savedColumns != null)
        {
            columns = savedColumns.filter(col => fields.map(f => f.FieldId).includes(col.field));
            columns.filter(c => !c.width).forEach(c => c.width = "90px");
        }
        else
        {
            const defaultFieldIds = [FieldId.AlternativeName, FieldId.AlternativeDescription, FieldId.AlternativeModified, FieldId.AlternativeStatusName];

            columns = fields.filter(f => defaultFieldIds.includes(f.FieldId))
                .map(f => ({
                    field: f.FieldId,
                    title: f.ColumnTitle,
                    format: f.Format,
                    hidden: f.ColumnHidden
                }));
        }

        if (this.rm.Readonly === false || this.Form != null)
        {
            const show = (e: MouseEvent) =>
            {
                e.preventDefault();

                const grid = this.grid.Get();
                const targetElement = e.currentTarget as HTMLElement;
                const dataItem: kendo.data.ObservableObject = grid.dataItem($(targetElement).closest("tr"));
                this.showAlternativeEditor(dataItem.get(FieldId.Id));
            }

            columns.unshift({ title: "", width: "90px", command: [{ text: "Edit", click: show }] });
        }

        const gridOptions = KendoGridOptions.CreateDefault();
        gridOptions.SetColumns(columns);
        gridOptions.SetGroupable(true);
        gridOptions.SetHeight(GetVhPixels(90));
        gridOptions.SetSelectable(this.rm.Readonly === false || (this.Form != null && this.Form.IncludeStatus));

        const getSelectedIds = (e: any) =>
        {
            const selectedRows = e.sender.select();

            this.SelectedAlternatives = [];

            for (const r of selectedRows)
            {
                const dataItem = e.sender.dataItem(r);
                const alternative = this.Alternatives.find(a => a.AlternativeId === Number(dataItem[FieldId.AlternativeId]));

                this.SelectedAlternatives.push(alternative);
            }
        }

        gridOptions.SetOnGridChange(getSelectedIds);

        const resetSelectedAlternatives = () => { this.SelectedAlternatives = []; }
        const grid = new KendoGrid(FieldId.AlternativeId, fields, resetSelectedAlternatives);
        grid.SetCustomColumnMenu(gridOptions);
        grid.LoadSettings(gridJsonOptions);

        const getColor = (e: any) => this.Alternatives.find(a => a.AlternativeId === Number(e[FieldId.AlternativeId])).BgColor;
        const getMaxValue = (field: any) => Math.max(...this.grid.GetData().map(row => row[field]).filter(v => v != null));

        grid.SetProgressBarColor(getColor);
        grid.SetProgressBarMaxValue(getMaxValue);

        this.grid = grid;
        this.grid.Render1("pbGrid", gridOptions);
    }

    setGridData()
    {
        if (!this.grid) return;
        const data = this.Alternatives.map(a => a.buildGridRow());
        this.grid.SetData(data);
        this.grid.RenderProgressBars();
        this.grid.RenderCumulativeColumns();
    }

    exportGrid()
    {
        if (this.grid)
        {
            this.grid.Export();
        }
    }


    createMetric()
    {
        const metric = new MetricOptions();
        metric.MetricId = guid();

        const vm = new MetricVM(this, metric);
        vm.IsEdited = true;

        this.Metrics.push(vm);
    }

    createScatterChart()
    {
        const chart: ChartOptions =
        {
            ChartId: guid(),
            Title: "",
            OrderValue: 0,
            Size: "Default",
            ScatterChartOptions:
            {
                XAxisAttributeId: null,
                YAxisAttributeId: null,
                OrderByAttributeId: null,
                StatusesShapes: []
            }
        };

        const chartVM = new ScatterChartVM(this, chart);
        chartVM.IsEdited = true;
        chartVM.OrderValue = this.MaxChartOrderValue + 1;
        this.Charts.push(chartVM);
    }

    createBalancingChart()
    {
        const chart: ChartOptions =
        {
            ChartId: guid(),
            Title: "",
            OrderValue: 0,
            Size: "Default",
            BalancingChartOptions:
            {
                AttributeId: null,
                MetricType: "Total",
                StatusesIds: []
            }
        };

        const chartVM = new BalancingChartVM(this, chart);
        chartVM.IsEdited = true;
        chartVM.OrderValue = this.MaxChartOrderValue + 1;
        this.Charts.push(chartVM);
    }

    createBubbleChart()
    {
        const chartOptions: ChartOptions =
        {
            ChartId: guid(),
            Title: "",
            OrderValue: 0,
            Size: "Default",
            BubbleChartOptions: {
                StatusesIds: [],
                XAxisAttributeId: null,
                YAxisAttributeId: null,
                ZAxisOption: null
            }
        };

        const chartVM = new BubbleChartVM(this, chartOptions);
        chartVM.IsEdited = true;
        chartVM.OrderValue = this.MaxChartOrderValue + 1;
        this.Charts.push(chartVM);
    }

    showFullScreen(ch: ChartVM)
    {
        this.fullScreenChart = ch;
        this.ResetHighlight();
    }

    handleCreateStaticViewCommand(name: string)
    {
        this.invokeCreateStaticViewCommandV1(this.workspaceId, guid(), this.rm.AlternativesListId, this.SelectedAlternatives.map(a => a.AlternativeId), name);
    }

    handleUpdateReportCommand(data: ReportEditorData)
    {
        this.invokeUpdateReportCommandV1(this.workspaceId, data.Id, data.Name, data.Description);
    }

    handleAddAlternativesToStaticViewCommand(viewDefId: string)
    {
        if (this.SelectedAlternatives.length > 0)
        {
            this.invokeAddAlternativesToStaticViewCommandV1(this.workspaceId, viewDefId, this.rm.AlternativesListId, this.SelectedAlternatives.map(a => a.AlternativeId));
        }
    }

    handleRemoveAlternativesFromStaticViewCommand()
    {
        if (this.IsStaticList && this.SelectedAlternatives.length > 0)
        {
            if (confirm(`Are you sure you want to exclude ${this.SelectedAlternatives.length} ${this.rm.AlternativesLabel.toLowerCase()} from ${this.SelectedList.Name} list?`))
            {
                const alternativesIds = this.SelectedAlternatives.map(a => a.AlternativeId);

                this.invokeRemoveAlternativesFromStaticViewCommandV1(this.workspaceId, this.SelectedList.Id, this.rm.AlternativesListId, alternativesIds);
            }
        }
    }

    handleUpdatePortfolioBalancerReportCommand()
    {
        const options: PortfolioBalancerReportSettings =
        {
            ListId: this.SelectedList?.Id,
            AlternativesFormId: this.Form?.Id,
            GroupByAttributeId: this.GroupByAttribute?.Id,
            Charts: this.Charts.map(a => a.GetSaveOptions()).filter(a => a != null),
            Metrics: this.Metrics.map(a => a.GetData()),
            GridOptions: this.grid.GetJsonSettings()
        };

        this.invokeUpdatePortfolioBalancerReportCommandV1(this.workspaceId, this.projectId, this.reportId, options);
    }

    handleUpdateMultipleAlternativesStatusCommand(statusId: number)
    {
        const ids = this.SelectedAlternatives.map(a => a.Id);

        if (ids.length > 0)
        {
            this.invokeUpdateMultipleAlternativesStatusCommandV1(this.rm.UserId, this.workspaceId, this.projectId, this.rm.AlternativesListId, ids, statusId);
        }
    }

    handleMultipleAlternativesAttributeValueUpdateCommand(value: string, attrId: string)
    {
        const ids = this.SelectedAlternatives.map(a => a.Id);

        if (ids.length > 0)
        {
            this.invokeUpdateMultipleAlternativesAttributeValueCommandV1(this.rm.UserId, this.workspaceId, this.projectId, this.rm.AlternativesListId, ids, Number.parseInt(attrId), value)
        }
    }

    populateBulkEditableAttributesBySection()
    {
        const attributes = this.rm.Attributes.filter(a => !a.IsMultivalue && !a.IsMetric).filter(a => a.IsList || (a.IsNumeric && a.IsManual));

        // First, sort by Section and then by Name
        const sorted = attributes.sort((a, b) =>
        {
            if (a.Section === b.Section)
            {
                return a.Name.localeCompare(b.Name);
            }
            return a.Section.localeCompare(b.Section);
        });

        // Then, group by Section
        const groupedAndSorted = sorted.reduce((acc, attribute) =>
        {
            if (!acc[attribute.Section])
            {
                acc[attribute.Section] = [];
            }
            acc[attribute.Section].push(attribute);
            return acc;
        }, {} as Record<string, AttributeReadModel[]>);

        this.BulkEditableAttributesBySection = [];

        Object.entries(groupedAndSorted).forEach(([section, attrs]) =>
        {
            this.BulkEditableAttributesBySection.push({ Section: section, Items: attrs })
        });
    }


    mounted()
    {
        $(window).on('resize scroll', () =>
        {
            this.ResetHighlight();
        });

        this.runPortfolioBalancerReportPageQueryV1(this.workspaceId, this.projectId, this.reportId)
    }

    onSetModel(model: any, modelName: string)
    {
        if (modelName === "ReportReadModel")
        {
            this.rm.Report = model as ReportReadModel;
        }
        else if (modelName === "PortfolioBalancerReportReadModel")
        {
            this.rm = model as PortfolioBalancerReportReadModel;

            document.title = `${this.rm.Report.Name} | TransparentChoice`;

            this.OnSeriesClick = (e: kendo.dataviz.ui.ChartSeriesClickEvent) =>
            {
                if (this.rm.Readonly === false || this.Form != null)
                {
                    this.showAlternativeEditor(e.dataItem.AlternativeId);
                }
            }

            this.Highlight = (e: kendo.dataviz.ui.ChartSeriesHoverEvent) =>
            {
                if (this.Charts.some(a => a.Chart.IsFullScreen))
                {
                    return;
                }

                const alternativeId = e.dataItem.AlternativeId as number;

                this.Charts
                    .filter(a => a.Type === 'scatter' || a.Type === 'bubble')
                    .filter(a => a.Chart != null && a.Chart.IsInViewPort() === true)
                    .map(a => a.Chart)
                    .forEach(chart =>
                    {
                        chart.ToggleHighlight(false, () => { return true; });
                        chart.ToggleHighlight(true, (point: any) => { return point.dataItem.AlternativeId === alternativeId; }); //highlight the point where the Ids match
                        chart.HideTooltip();
                    });

                e.sender.showTooltip((point: any) => { return point.dataItem.AlternativeId === alternativeId; }); //show the tooltip for the point where the Ids match
            }

            this.populateBulkEditableAttributesBySection();

            this.SelectedList = this.rm.Lists.find(a => a.Id === this.rm.AlternativesViewId) ?? null;
            this.Form = this.rm.Forms.find(f => f.Id === this.rm.AlternativesFormId) ?? null;
            this.GroupByAttribute = this.rm.Attributes.find(a => a.Id === this.rm.GroupByAttributeId) ?? null;

            this.Alternatives = this.rm.Alternatives.map(a => new AlternativeViewModel(this, a));
            this.BuildAlternativesGroups();

            this.Charts = this.rm.Charts.reduce((acc: ChartVM[], chartOptions) =>
            {
                let chartVM: ChartVM | null = null;

                // Determine the type of chart and create the appropriate VM.
                if (chartOptions?.ScatterChartOptions != null)
                {
                    chartVM = new ScatterChartVM(this, chartOptions);
                }
                else if (chartOptions?.BalancingChartOptions != null)
                {
                    chartVM = new BalancingChartVM(this, chartOptions);
                }
                else if (chartOptions?.BubbleChartOptions != null)
                {
                    chartVM = new BubbleChartVM(this, chartOptions);
                }

                // Common logic for setting OrderValue, only if a chartVM was created.
                if (chartVM)
                {
                    chartVM.OrderValue = chartOptions.OrderValue ?? this.MaxChartOrderValue + 1;
                    acc.push(chartVM);
                }

                return acc;
            }, []);
            this.Charts.forEach(ch => ch.SetData());

            this.Metrics = this.rm.Metrics.map(a => new MetricVM(this, a));
            this.Metrics.forEach(m => m.setValue());

            nextTick(() =>
            {
                this.renderGrid(this.rm.GridOptions);

                this.setGridData();

                this.Charts.forEach(a => a.Render());

                this.initialized = true;
            })
        }
        else if (modelName == "AlternativesViewReadModel")
        {
            const rm = model as AlternativesViewReadModel;

            const curr = this.rm.Lists.find(a => a.Id === rm.Id);

            if (curr)
            {
                this.rm.Lists.remove(curr);
            }

            this.rm.Lists.push(rm);
        }
        else if (modelName === "AlternativeReadModel")
        {
            const rm = model as AlternativeReadModel;
            const current = this.Alternatives.find(a => a.AlternativeId === rm.AlternativeId);
            current.UpdateAlternative(rm);

            this.alternativeEditorDialog.close();
        }
        else if (modelName === "AlternativesReadModel")
        {
            const rm = model as AlternativesReadModel;

            this.Alternatives = rm.Alternatives.map(a => new AlternativeViewModel(this, a));
            this.BuildAlternativesGroups();

            this.setGridData();
            this.Charts.forEach(ch => ch.SetData());
            this.Metrics.forEach(m => m.setValue());
        }
        else if (modelName === "AlternativesComparisonReadModel")
        {
            const rm = model as AlternativesComparisonReadModel;
            this.alternativesComparisonDialog.setData(rm);
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (UpdateReportCommandV1.matchType(cmd))
        {
            this.runReportQueryV1(this.workspaceId, this.reportId);
            this.reportEditor.close();
        }
        else if (UpdatePortfolioBalancerReportCommandV1.matchType(cmd))
        {
            alert("Done");
        }
        else if (CreateStaticViewCommandV1.matchType(cmd))
        {
            this.runAlternativesViewQueryV1(this.workspaceId, this.rm.AlternativesListId, correlationId);
            this.staticViewBuilder.close();
        }
        else if (AddAlternativesToStaticViewCommandV1.matchType(cmd))
        {
            alert("Done");
        }
        else if (RemoveAlternativesFromStaticViewCommandV1.matchType(cmd))
        {
            const cmd1 = cmd as RemoveAlternativesFromStaticViewCommandV1;

            this.Alternatives = this.Alternatives.filter(a => cmd1.AlternativesIds.includes(a.AlternativeId) === false);
            this.BuildAlternativesGroups();
            this.setGridData();
            this.Charts.forEach(ch => ch.SetData());
            this.Metrics.forEach(m => m.setValue());
        }
        else if (UpdateAlternativeCommandV1.matchType(cmd))
        {
            this.runAlternativeQueryV1(this.workspaceId, this.projectId, this.rm.AlternativesListId, correlationId, true)
        }
        else if (UpdateMultipleAlternativesStatusCommandV1.matchType(cmd))
        {
            const cmd1 = cmd as UpdateMultipleAlternativesStatusCommandV1;

            const status = this.rm.Statuses.find(a => a.Id === cmd1.StatusId);

            this.Alternatives.filter(a => cmd1.AlternativeIds.includes(a.Id)).forEach(updated =>
            {
                updated.UpdateStatus(status.Id, status.Name);
            });

            this.Charts.forEach(ch => ch.SetData());
            this.Metrics.forEach(m => m.setValue());

            this.statusListSelectionDialog.close();
        }
        else if (UpdateMultipleAlternativesAttributeValueCommandV1.matchType(cmd))
        {
            const cmd1 = cmd as UpdateMultipleAlternativesAttributeValueCommandV1;

            const attr = this.rm.Attributes.find(a => a.Id === cmd1.AttributeId);

            this.Alternatives.filter(a => cmd1.AlternativeIds.includes(a.Id)).forEach(updated =>
            {
                updated.UpdateAttributeValue(attr, cmd1.Value);
            });

            this.BuildAlternativesGroups();
            this.Charts.forEach(ch => ch.SetData());
            this.Metrics.forEach(m => m.setValue());
            this.grid.RenderProgressBars();
            this.grid.RenderCumulativeColumns();

            this.attrListSelectionDialog.close();
            if (this.numericInputDialog) this.numericInputDialog.isOpened = false;
        }
    }

    onCommandFailed(status: ICommandStatus)
    {
        if (CreateStaticViewCommandV1.matchType(status.Command))
        {
            this.staticViewBuilder.displayValidationErrors(status.ValidationErrors);
        }
        else if (UpdateReportCommandV1.matchType(status.Command))
        {
            this.reportEditor.displayValidationErrors(status.ValidationErrors);
        }
    }
}

abstract class ChartVM
{
    page: PortfolioBalancerReportPage = null;
    isRendered: boolean = false;

    Type: string;
    ChartId: string;
    AlternativesStatusIncludes: AlternativesStatusIncludeVM[];
    IsEdited: boolean = false;

    OrderValue: number = null;
    Size: string = null;
    Title: string = null;
    Chart: KendoChart = null;

    get ChartCssClass(): string
    {
        if (this.Size === "Large")
        {
            return "col-md-12 col-sm-12 chart-large";
        }
        else if (this.Size === "Wide")
        {
            return "col-md-12 col-sm-12 chart-wide";
        }
        else
        {
            return "col-md-6 col-sm-12 chart-default";
        }
    }

    constructor(page: PortfolioBalancerReportPage, chartOptions: ChartOptions, type: string)
    {
        this.page = page;

        this.ChartId = chartOptions.ChartId;
        this.Title = chartOptions.Title;
        this.Type = type;
        this.AlternativesStatusIncludes = this.page.rm.Statuses.map(status => new AlternativesStatusIncludeVM(status));

        this.OrderValue = chartOptions.OrderValue;
        this.Size = chartOptions.Size ?? "Default";
    }

    abstract GetSaveOptions(): ChartOptions;

    abstract SetData(): void;

    abstract cloneChart(): void;

    Render()
    {
        if (this.isRendered === false)
        {
            this.Chart.Render1(this.ChartId);
            this.isRendered = true;
        }
    }

    moveUp()
    {
        const index = this.page.ChartsView.findIndex(a => a.ChartId === this.ChartId);
        if (index === 0) return;

        const prevChartVM = this.page.ChartsView[index - 1];
        prevChartVM.OrderValue = this.OrderValue;
        this.OrderValue = this.OrderValue - 1;
    }

    moveDown()
    {
        const index = this.page.ChartsView.findIndex(a => a.ChartId === this.ChartId);
        if (index === this.page.ChartsView.length - 1) return;

        const nextChartVM = this.page.ChartsView[index + 1];
        nextChartVM.OrderValue = this.OrderValue;
        this.OrderValue = this.OrderValue + 1;
    }

    setSize(size: string)
    {
        this.Size = size;

        nextTick(() =>
        {
            this.Chart.UpdateOptions();
        })
    }

    stopEditing()
    {
        this.IsEdited = false;

        nextTick(() =>
        {
            this.Render();
            this.SetData();
        });
    }

    deleteChart()
    {
        if (confirm("Are you sure you want to delete this chart?"))
        {
            this.page.Charts
                .filter(chart => chart.OrderValue > this.OrderValue)
                .forEach(chart => chart.OrderValue = chart.OrderValue - 1);


            this.page.Charts.remove(this);
        }
    }
}

class ScatterChartVM extends ChartVM
{
    XAxisAttribute: AttributeReadModel = null;
    YAxisAttribute: AttributeReadModel = null;
    RunningTotalOrderAttribute: AttributeReadModel = null;

    get ShapesLegend(): AlternativesStatusIncludeVM[] { return this.AlternativesStatusIncludes.filter(a => a.Shape !== 'none'); }

    constructor(page: PortfolioBalancerReportPage, chartOptions: ChartOptions)
    {
        super(page, chartOptions, "scatter");

        if (chartOptions.ScatterChartOptions.XAxisAttributeId)
        {
            this.XAxisAttribute = this.page.NumericAttributes.find(a => a.Id === chartOptions.ScatterChartOptions.XAxisAttributeId);
        }

        if (chartOptions.ScatterChartOptions.YAxisAttributeId)
        {
            this.YAxisAttribute = this.page.NumericAttributes.find(a => a.Id === chartOptions.ScatterChartOptions.YAxisAttributeId);
        }

        if (chartOptions.ScatterChartOptions.OrderByAttributeId)
        {
            this.RunningTotalOrderAttribute = this.page.NumericAttributes.find(a => a.Id === chartOptions.ScatterChartOptions.OrderByAttributeId);
        }

        const statusesShapes = chartOptions.ScatterChartOptions.StatusesShapes || [];

        for (const status of this.AlternativesStatusIncludes)
        {
            const statusShape = statusesShapes.find(a => a.AlternativeStatusId === status.Id);

            if (statusShape)
            {
                status.Shape = statusShape.Shape;
            }
        }

        const options = new KendoChartOptions();
        options.HideLegend();
        options.SetPannable(true);
        options.SetZoomable(true);
        options.SetTooltip(false, '#= dataItem.Name #');
        options.SetOnSeriesHover(this.page.Highlight);
        options.SetOnSeriesClick(this.page.OnSeriesClick);

        const chart = KendoChart.CreateScatterChart(options);
        this.Chart = chart;
    }

    SetData()
    {
        if (this.XAxisAttribute == null || this.YAxisAttribute == null) return;

        if (!this.Title && this.XAxisAttribute && this.YAxisAttribute)
        {
            this.Title = `${this.YAxisAttribute.Name} vs. ${this.XAxisAttribute.Name}`;
        }

        const statusesIncludes = this.AlternativesStatusIncludes.filter(s => s.Shape !== "none");
        const alternatives = this.page.Alternatives.filter(a => statusesIncludes.map(a => a.Id).includes(a.StatusId));

        let dataItems: { AlternativeId: string, Name: string, StatusId: number, Color: string, X: number, Y: number, Z?: number, TooltipHtml: string }[] = [];

        for (const alternativeVM of alternatives)
        {
            const xValue = alternativeVM.AttributeValues.find(a => a.Value != null && a.AttributeId === this.XAxisAttribute.Id)?.Value;
            const yValue = alternativeVM.AttributeValues.find(a => a.Value != null && a.AttributeId === this.YAxisAttribute.Id)?.Value;
            const zValue = this.RunningTotalOrderAttribute != null ? alternativeVM.AttributeValues.find(a => a.Value != null && a.AttributeId === this.RunningTotalOrderAttribute.Id)?.Value : null;

            dataItems.push({
                Name: alternativeVM.Name,
                X: xValue as number,
                Y: yValue as number,
                Z: zValue as number,
                AlternativeId: alternativeVM.Id,
                StatusId: alternativeVM.StatusId,
                Color: alternativeVM.Color,
                TooltipHtml: `<div style="text-align: left;"><h5>${alternativeVM.Name}</h5><p>${this.XAxisAttribute.Name}: ${xValue}<p/><p>${this.YAxisAttribute.Name}: ${yValue}<p/></div>`
            });
        }

        dataItems = dataItems.filter(a => a.X != null && a.Y != null);

        if (this.RunningTotalOrderAttribute != null)
        {
            dataItems = dataItems
                .filter(a => a.Z != null)
                .sort((a, b) => numCompare(a.Z, b.Z))
                .reverse();

            for (let i = 1; i < dataItems.length; i++) //from 1 to skip first
            {
                dataItems[i].X += dataItems[i - 1].X;
                dataItems[i].Y += dataItems[i - 1].Y;
            }
        }

        const series: KendoChartDataSerie[] = statusesIncludes.map(statusInclude =>
        {
            const serie = new KendoChartDataSerie();
            //serie.SetName(group.Name);
            serie.SetXField("X");
            serie.SetYField("Y");
            serie.SetCategoryField("Name");
            serie.SetColorField("Color");
            serie.SetMarkers(true, statusInclude.Shape); // circle, square, triangle, cross
            serie.SetData(dataItems.filter(a => a.StatusId === statusInclude.Id));

            return serie;
        });

        const options = this.Chart.GetOptions();
        options.SetTooltip(true, "#= dataItem.TooltipHtml #");

        const xAxisTitle = this.XAxisAttribute ? this.XAxisAttribute.Name : "";
        const yAxisTitle = this.YAxisAttribute ? this.YAxisAttribute.Name : "";

        const xMaxValue = Math.max(...dataItems.map(v => v.X));
        const xMinValue = Math.min(...dataItems.map(v => v.X));
        const yMaxValue = Math.max(...dataItems.map(v => v.Y));
        const yMinValue = Math.min(...dataItems.map(v => v.Y));

        const xAxisMin = xMinValue * 0.9;
        const xAxisMax = xMaxValue * 1.1;
        const yAxisMin = yMinValue * 0.9;
        const yAxisMax = yMaxValue * 1.1;

        const xAxisLabelFormat = xMaxValue > 10 ? "{0:n0}" : null;
        const yAxisLabelFormat = yMaxValue > 10 ? "{0:n0}" : null;

        if (this.RunningTotalOrderAttribute != null)
        {
            const xCrosshairTooltipTemplate = (e: any): string =>
            {
                if (!xMaxValue)
                {
                    return null;
                }

                return kendo.toString(e.value / xMaxValue, "p0");
            }

            const yCrosshairTooltipTemplate = (e: any): string =>
            {
                if (!yMaxValue)
                {
                    return null;
                }

                return kendo.toString(e.value / yMaxValue, "p0");
            }

            options.SetXAxis(null, xAxisMin, xAxisMax, xAxisTitle, xAxisLabelFormat, 2, true, true, null, xCrosshairTooltipTemplate);
            options.SetYAxis(null, yAxisMin, yAxisMax, yAxisTitle, yAxisLabelFormat, true, true, null, yCrosshairTooltipTemplate);
        }
        else
        {
            options.SetXAxis(null, xAxisMin, xAxisMax, xAxisTitle, xAxisLabelFormat, 2, true, false, null, null);
            options.SetYAxis(null, yAxisMin, yAxisMax, yAxisTitle, yAxisLabelFormat, true, false, null, null);
        }

        this.Chart.SetOptions(options);
        this.Chart.SetDataSeries(series);

        this.Chart.UpdateOptions();
    }

    GetSaveOptions(): ChartOptions
    {
        return {
            ChartId: this.ChartId,
            Title: this.Title,
            Size: this.Size,
            OrderValue: this.OrderValue,
            ScatterChartOptions: {
                XAxisAttributeId: this.XAxisAttribute?.Id ?? 0,
                YAxisAttributeId: this.YAxisAttribute?.Id ?? 0,
                OrderByAttributeId: this.RunningTotalOrderAttribute?.Id,
                StatusesShapes: this.AlternativesStatusIncludes.map(a => { return { AlternativeStatusId: a.Id, Shape: a.Shape }; })
            }
        }
    }

    cloneChart()
    {
        const clone = this.GetSaveOptions();
        clone.ChartId = guid();
        clone.Title += " (copy)";

        const chartVM = new ScatterChartVM(this.page, clone);
        chartVM.IsEdited = true;
        chartVM.OrderValue = this.page.MaxChartOrderValue + 1;
        this.page.Charts.push(chartVM);
    }
}

class BalancingChartVM extends ChartVM
{
    MetricType: string = "Total";
    Attribute: AttributeReadModel = null;

    constructor(page: PortfolioBalancerReportPage, chartOptions: ChartOptions)
    {
        super(page, chartOptions, "balancing");

        this.MetricType = chartOptions.BalancingChartOptions.MetricType;

        if (chartOptions.BalancingChartOptions.AttributeId)
        {
            this.Attribute = this.page.NumericAttributes.find(a => a.Id === chartOptions.BalancingChartOptions.AttributeId);
        }

        const includedIds = new Set(chartOptions.BalancingChartOptions.StatusesIds || []);
        this.AlternativesStatusIncludes.forEach(s => s.Included = includedIds.has(s.Id));

        const options = new KendoChartOptions();
        options.SetSeriesStack(true);
        options.SetCategoryAxis(false, false);
        options.SetValueAxis(null, false, false);
        options.HideLegend();

        const chart = KendoChart.CreateColumnChart(options);
        this.Chart = chart;
    }

    private GetDefaultTitle(): string
    {
        if (this.Attribute)
        {
            return `${this.Attribute.Name} (${this.MetricType})`;
        }
        else
        {
            return "Number of projects";
        }
    }

    SetData()
    {
        if (isNullOrWhitespace(this.Title))
        {
            this.Title = this.GetDefaultTitle();
        }

        const series: KendoChartDataSerie[] = [];

        const statusesIds = this.AlternativesStatusIncludes.filter(a => a.Included).map(a => a.Id);
        const groups = this.page.AlternativesGroups;

        for (let i = 0; i < groups.length; i++)
        {
            const group = groups[i];

            const alternatives = this.page.Alternatives.filter(alternative => statusesIds.includes(alternative.StatusId) && alternative.Group === group.Name);

            const serie = new KendoChartDataSerie();
            serie.SetName(group.Name);
            serie.SetField("Value");
            serie.SetCategoryField("Name");
            serie.SetColor(group.Color);

            const data = [];

            for (let j = 0; j < groups.length; j++)
            {
                let value = 0;

                if (i === j)
                {
                    value = MetricVM.CalculateMetricValue(this.Attribute?.Id, alternatives, this.MetricType);
                }

                const item = { Name: group.Label, Value: value };
                data.push(item);
            }

            serie.SetData(data);
            series.push(serie);
        }

        this.Chart.SetDataSeries(series);
        this.Chart.UpdateOptions();
    }

    GetSaveOptions()
    {
        const includedStatuses = this.AlternativesStatusIncludes.filter(a => a.Included === true).map(a => a.Id);

        const balancingChartOptions =
        {
            StatusesIds: includedStatuses,
            MetricType: this.MetricType,
            AttributeId: this.Attribute?.Id
        }

        return {
            ChartId: this.ChartId,
            Title: this.Title,
            Size: this.Size,
            OrderValue: this.OrderValue,
            BalancingChartOptions: balancingChartOptions
        }
    }

    cloneChart()
    {
        const clone = this.GetSaveOptions();
        clone.ChartId = guid();
        clone.Title += " (copy)";

        const chartVM = new BalancingChartVM(this.page, clone);
        chartVM.IsEdited = true;
        chartVM.OrderValue = this.page.MaxChartOrderValue + 1;
        this.page.Charts.push(chartVM);
    }
}

class BubbleChartVM extends ChartVM
{
    BubbleSizeOptions: { Label: string, Value: string }[] = [{ Label: "Equal", Value: "equal" }, { Label: "Ratio: X/Y", Value: "ratioXY" }, { Label: "Ratio: Y/X", Value: "ratioYX" }];

    XAxisAttribute: AttributeReadModel = null;
    YAxisAttribute: AttributeReadModel = null;
    ZAxisOption: { Label: string, Value: string } = null;

    get XaxisLabel(): string { return this.XAxisAttribute?.Name ?? "select..."; }
    get YaxisLabel(): string { return this.YAxisAttribute?.Name ?? "select..."; }

    constructor(page: PortfolioBalancerReportPage, chartOptions: ChartOptions)
    {
        super(page, chartOptions, "bubble");

        this.XAxisAttribute = chartOptions.BubbleChartOptions.XAxisAttributeId ? this.page.NumericAttributes.find(a => a.Id === chartOptions.BubbleChartOptions.XAxisAttributeId) : null;
        this.YAxisAttribute = chartOptions.BubbleChartOptions.YAxisAttributeId ? this.page.NumericAttributes.find(a => a.Id === chartOptions.BubbleChartOptions.YAxisAttributeId) : null;

        if (chartOptions.BubbleChartOptions.ZAxisOption)
        {
            switch (chartOptions.BubbleChartOptions.ZAxisOption)
            {
                case "equal": {
                    this.ZAxisSetEqualCommand();
                    break;
                }
                case "ratioXY": {
                    this.ZAxisSetXYRatioCommand();
                    break;
                }
                case "ratioYX": {
                    this.ZAxisSetYXRatioCommand();
                    break;
                }
                default: {
                    const attrId = chartOptions.BubbleChartOptions.ZAxisOption.startsWith("attribute") ? parseInt(chartOptions.BubbleChartOptions.ZAxisOption.replace("attribute", "")) : null;
                    const attr = this.page.NumericAttributes.find(a => a.Id === attrId);
                    this.ZAxisSetAttributeCommand(attr);
                    break;
                }
            }
        }
        else
        {
            this.ZAxisSetEqualCommand();
        }

        const includedIds = new Set(chartOptions.BubbleChartOptions.StatusesIds || []);
        this.AlternativesStatusIncludes.forEach(s => s.Included = includedIds.has(s.Id));

        const options = new KendoChartOptions();

        const tooltipTemplate = `
                <div style='padding: 5px;'>
                    <h4 style='margin-top:0;'>#= category #</h4>
                    <p><strong>X: #= kendo.format('{0:n}', value.x) # </strong><br/>(#= dataItem.xLabel #)</p>
                    <p><strong>Y: #= kendo.format('{0:n}', value.y) # </strong><br/>(#= dataItem.yLabel #)</p>
                    <p><strong>Z: #= kendo.format('{0:n}', value.size) #</strong><br/>(#= dataItem.zLabel #)</p>
                </div>`;

        //const tooltipTemplate = "<div style='padding: 5px;'>" +
        //    "<h4 style='margin-top:0;'>#= category #</h4>" +
        //    "<p><strong>X: #= kendo.format('{0:n}', value.x) # </strong><br/>(#= dataItem.xLabel #)</p>" +
        //    "<p><strong>Y: #= kendo.format('{0:n}', value.y) # </strong><br/>(#= dataItem.yLabel #)</p>" +
        //    "<p><strong>Z: #= kendo.format('{0:n}', value.size) #</strong><br/>(#= dataItem.zLabel #)</p>" +
        //    "</div>";

        options.SetTooltip(true, tooltipTemplate);
        options.SetXAxis(null, null, null, null, null, null, null, null, null);
        options.SetYAxis(null, null, null, null, null, null, null, null);
        options.SetPannable(true);
        options.SetZoomable(true);
        options.HideLegend();
        options.SetOnSeriesHover(this.page.Highlight);
        options.SetOnSeriesClick(this.page.OnSeriesClick);
        const chart = KendoChart.CreateBubbleChart(options);
        this.Chart = chart;
    }

    SetData()
    {
        if (this.XAxisAttribute == null || this.YAxisAttribute == null)
        {
            return;
        }

        if (isNullOrWhitespace(this.Title))
        {
            this.Title = "Bubble chart";
        }

        const yAxisOption = { Label: this.YAxisAttribute.Name, Value: `attribute${this.YAxisAttribute.Id}` };
        const xAxisOption = { Label: this.XAxisAttribute.Name, Value: `attribute${this.XAxisAttribute.Id}` };
        const zAxisOption = this.ZAxisOption;

        const xLabel = ellipsis(xAxisOption.Label, 40);
        const yLabel = ellipsis(yAxisOption.Label, 40);
        const zLabel = ellipsis(zAxisOption.Label, 40);

        const statusesIncludes = this.AlternativesStatusIncludes.filter(s => s.Included).map(a => a.Id);
        const alternatives = this.page.Alternatives.filter(a => statusesIncludes.indexOf(a.StatusId) !== -1);

        const dataItems = BubbleAnalysis.CreateChartData(alternatives, xAxisOption, yAxisOption, this.ZAxisOption);

        const options = this.Chart.GetOptions();

        const xAxisTitle = this.XAxisAttribute ? this.XAxisAttribute.Name : "";
        const yAxisTitle = this.YAxisAttribute ? this.YAxisAttribute.Name : "";

        const xMaxValue = Math.max(...dataItems.map(v => v.X));
        const xMinValue = Math.min(...dataItems.map(v => v.X));
        const yMaxValue = Math.max(...dataItems.map(v => v.Y));
        const yMinValue = Math.min(...dataItems.map(v => v.Y));

        const xAxisMin = xMinValue * 0.9;
        const xAxisMax = xMaxValue * 1.1;
        const yAxisMin = yMinValue * 0.9;
        const yAxisMax = yMaxValue * 1.1;

        const xAxisLabelFormat = xMaxValue > 10 ? "{0:n0}" : null;
        const yAxisLabelFormat = yMaxValue > 10 ? "{0:n0}" : null;

        options.SetXAxis(null, xAxisMin, xAxisMax, xAxisTitle, xAxisLabelFormat, 2, true, false, null, null);
        options.SetYAxis(null, yAxisMin, yAxisMax, yAxisTitle, yAxisLabelFormat, true, false, null, null);

        const series = dataItems.map(a =>
        {
            const serie = new KendoChartDataSerie();

            serie.SetColor(a.Color);
            serie.SetName(a.Name);
            serie.SetData([{
                x: a.X,
                y: a.Y,
                size: a.Size,
                category: ellipsis(a.Name, 40),
                xLabel: xLabel,
                yLabel: yLabel,
                zLabel: zLabel,
                AlternativeId: a.AlternativeId,
            }]);

            return serie;
        });

        this.Chart.SetDataSeries(series);
        this.Chart.SetOptions(options);
        this.Chart.UpdateOptions();
    }

    GetSaveOptions(): ChartOptions
    {
        return {
            ChartId: this.ChartId,
            Title: this.Title,
            Size: this.Size,
            OrderValue: this.OrderValue,
            BubbleChartOptions: {
                StatusesIds: this.AlternativesStatusIncludes.filter(a => a.Included === true).map(a => a.Id),
                XAxisAttributeId: this.XAxisAttribute?.Id ?? 0,
                YAxisAttributeId: this.YAxisAttribute?.Id ?? 0,
                ZAxisOption: this.ZAxisOption?.Value ?? 'equal'
            }
        }
    }

    cloneChart()
    {
        const clone = this.GetSaveOptions();
        clone.ChartId = guid();
        clone.Title += " (copy)";

        const chartVM = new BubbleChartVM(this.page, clone);
        chartVM.IsEdited = true;
        chartVM.OrderValue = this.page.MaxChartOrderValue + 1;
        this.page.Charts.push(chartVM);
    }

    ZAxisSetAttributeCommand(attr: AttributeReadModel)
    {
        this.ZAxisOption = { Label: attr.Name, Value: `attribute${attr.Id}` };
    }

    ZAxisSetEqualCommand()
    {
        this.ZAxisOption = { Label: "Equal", Value: "equal" };
    }

    ZAxisSetXYRatioCommand()
    {
        this.ZAxisOption = { Label: "Ratio: X/Y", Value: "ratioXY" };
    }

    ZAxisSetYXRatioCommand()
    {
        this.ZAxisOption = { Label: "Ratio: Y/X", Value: "ratioYX" };
    }
}

class MetricVM
{
    page: PortfolioBalancerReportPage = null;

    MetricId: string;
    AlternativesStatusIncludes: AlternativesStatusIncludeVM[] = [];
    IsEdited: boolean = false;
    Type: string = null;
    LimitMin: number = null;
    LimitMax: number = null;
    Attribute: AttributeReadModel = null;
    Title: string = null;
    Value: number = null;
    Decimals: number = null;
    Currency: string = null;
    Size: string = null;

    get ValueStr(): string | null
    {
        if (this.Value == null) return null;

        const options: Intl.NumberFormatOptions = { maximumFractionDigits: this.Decimals };

        if (this.Currency)
        {
            options.style = 'currency';
            options.currency = this.Currency;
        }

        return this.Value.toLocaleString('en-US', options);
    }

    get LimitMinStr(): string | null { return this.LimitMin ? `Min: ${this.LimitMin.toLocaleString('en-US')}` : null; }

    get LimitMaxStr(): string | null { return this.LimitMax ? `Max: ${this.LimitMax.toLocaleString('en-US')}` : null; }

    get Color(): string { return (this.LimitMin && this.Value && this.LimitMin > this.Value) || (this.LimitMax && this.Value && this.LimitMax < this.Value) ? "red" : "black"; }

    get WidthCss(): string
    {
        const sizeToCssClassMap: { [key: string]: string } = {
            "1/2": "col-md-6 col-sm-6 col-xs-12",
            "1/4": "col-md-3 col-sm-6 col-xs-12",
        };

        return sizeToCssClassMap[this.Size] || "col-md-4 col-sm-6 col-xs-12";
    }

    constructor(page: PortfolioBalancerReportPage, metric: MetricOptions)
    {
        this.page = page;

        this.MetricId = metric.MetricId;
        this.Type = metric.Type;
        this.LimitMin = metric.LimitMin;
        this.LimitMax = metric.LimitMax;
        this.Currency = metric.Currency;
        this.Decimals = metric.Decimals;
        this.Size = metric.Size ?? "1/3";

        this.Attribute = metric.AttributeId ? this.page.NumericAttributes.find(a => a.Id === metric.AttributeId) : null;

        this.AlternativesStatusIncludes = this.page.rm.Statuses.map(a => new AlternativesStatusIncludeVM(a));

        this.AlternativesStatusIncludes.forEach(include =>
        {
            include.Included = (metric.IncludedStatusesIds || []).includes(include.Id);
        });

        this.Title = metric.Title ?? (this.Attribute == null ? "Number of projects" : `${this.Attribute.Name} (${this.Type})`);
    }

    GetData(): MetricOptions
    {
        const metric = new MetricOptions();
        metric.MetricId = this.MetricId;
        metric.AttributeId = this.Attribute?.Id;
        metric.Type = this.Type;
        metric.Title = this.Title;
        metric.IncludedStatusesIds = this.AlternativesStatusIncludes.filter(a => a.Included).map(a => a.Id);
        metric.LimitMin = this.LimitMin;
        metric.LimitMax = this.LimitMax;
        metric.Currency = this.Currency;
        metric.Decimals = this.Decimals;
        metric.Size = this.Size;
        return metric;
    }

    moveUp()
    {
        const orderValue = this.page.Metrics.indexOf(this);

        if (orderValue > 0)
        {
            arrayMove(this.page.Metrics, orderValue, orderValue - 1);
        }
    }

    moveDown()
    {
        const orderValue = this.page.Metrics.indexOf(this);

        if (orderValue < this.page.Metrics.length - 1)
        {
            arrayMove(this.page.Metrics, orderValue, orderValue + 2);
        }
    }

    closeEditor()
    {
        this.setValue();
        this.IsEdited = false;
    }

    setValue()
    {
        const alternatives = this.page.Alternatives.filter(a => this.AlternativesStatusIncludes.filter(a => a.Included).map(a => a.Id).includes(a.StatusId));
        this.Value = MetricVM.CalculateMetricValue(this.Attribute?.Id, alternatives, this.Type);
    }

    deleteMetric()
    {
        if (confirm("Are you sure you want to delete this metric?"))
        {
            this.page.Metrics.remove(this);
        }
    }

    clone()
    {
        const clone = this.GetData();
        clone.MetricId = guid();

        const cloneVM = new MetricVM(this.page, clone);
        cloneVM.IsEdited = true;

        this.page.Metrics.push(cloneVM);
    }

    static CalculateMetricValue(attributeId: number, alternatives: AlternativeViewModel[], metricType: string): number | null
    {
        if (attributeId == null) return alternatives.length;

        const values = alternatives
            .map(a => a.AttributeValues)
            .reduce((a, b) => a.concat(b), [])
            .filter(v => v.Value != null)
            .filter(v => v.AttributeId === attributeId)
            .map(v => v.Value as number);


        const metricCalculations: { [key: string]: () => number } = {
            Max: () => Math.max(...values),
            Min: () => Math.min(...values),
            Total: () => values.reduce((s, c) => s + c, 0),
            Avg: () => average(values),
        };

        const calculationFunction = metricCalculations[metricType];

        if (calculationFunction)
        {
            return calculationFunction();
        }

        return null;
    }
}

class AlternativeViewModel
{
    _dataItem: kendo.data.Model = null;
    page: PortfolioBalancerReportPage = null;
    rm: AlternativeReadModel = null;

    get dataItem(): kendo.data.Model
    {
        if (this._dataItem == null)
        {
            this._dataItem = this.page.grid.GetDataItem(this.AlternativeId);
        }

        return this._dataItem;
    }

    get Id() { return this.rm.Id; }
    get AlternativeId() { return this.rm.AlternativeId; }
    get Name() { return this.rm.Name; }
    get Description() { return this.rm.Description; }
    get StatusId() { return this.rm.StatusId; }
    get StatusName() { return this.rm.StatusName; }

    get Modified(): Date | null { return this.rm.Modified ? new Date(this.rm.Modified) : null; }
    get StartDate(): Date | null { return this.rm.StartDate ? new Date(this.rm.StartDate) : null; }
    get CommitmentDate(): Date | null { return this.rm.CommitmentDate ? new Date(this.rm.CommitmentDate) : null; }

    get Created(): Date { return new Date(this.rm.Created); }
    get AttributeValues() { return this.rm.AttributeValues; }

    Color: string;
    BgColor: string;
    Group: string | null = null;

    constructor(page: PortfolioBalancerReportPage, rm: AlternativeReadModel)
    {
        this.page = page;
        this.rm = rm;

        this.Color = "#56565a";
        this.BgColor = "bg-tch-gray";
    }

    buildGridRow(): KendoGridRow
    {
        const row: KendoGridRow = {
            [FieldId.Id]: this.Id,
            [FieldId.AlternativeId]: this.AlternativeId,
            [FieldId.AlternativeName]: this.Name,
            [FieldId.AlternativeDescription]: this.Description,
            [FieldId.AlternativeCreated]: this.Created,
            [FieldId.AlternativeModified]: this.Modified,
            [FieldId.AlternativeStatusName]: this.StatusName,
            [FieldId.AlternativeStartDate]: this.StartDate,
            [FieldId.AlternativeCommitmentDate]: this.CommitmentDate,
        };

        this.page.rm.Attributes.forEach(attr => 
        {
            //row[FieldId.Attribute(attr.Id)] = AlternativesUtils.processAttributeValues(attr, this.AttributeValues);

            row[FieldId.Attribute(attr.Id)] = attr.IsMultivalue === true ?
                (JSON.parse(this.AttributeValues.find(a => a.AttributeId === attr.Id).Value) as any[]).join(';') :
                this.AttributeValues.find(a => a.AttributeId === attr.Id).Value;
        });

        return row;
    }

    UpdateStatus(statusId: number, statusName: string)
    {
        this.rm.StatusId = statusId;
        this.rm.StatusName = statusName;

        this.dataItem.set(FieldId.AlternativeStatusName, this.StatusName);
    }

    UpdateAlternative(rm: AlternativeReadModel)
    {
        this.rm = rm;

        this.dataItem.set(FieldId.AlternativeName, this.Name);
        this.dataItem.set(FieldId.AlternativeDescription, this.Description);
        this.dataItem.set(FieldId.AlternativeModified, this.Modified);
        this.dataItem.set(FieldId.AlternativeStatusName, this.StatusName);

        this.page.rm.Attributes.forEach(attr => 
        {
            this.dataItem.set(FieldId.Attribute(attr.Id), AlternativesUtils.processAttributeValues(attr, this.AttributeValues));
        });
    }

    UpdateAttributeValue(attr: AttributeReadModel, strVal: string)
    {
        const val = AlternativesUtils.parseValue(attr, strVal);

        this.rm.AttributeValues = this.rm.AttributeValues.filter(a => a.AttributeId !== attr.Id);

        if (val != null)
        {
            this.rm.AttributeValues.push({ AttributeId: attr.Id, HasValue: true, Value: val });
        }

        this.dataItem.set(FieldId.Attribute(attr.Id), val);
    }
}

class AlternativesStatusIncludeVM
{
    Id: number;
    Name: string;
    Included: boolean = true;
    Shape: string = "circle";

    get ShapeIcon(): string | null
    {
        //['none', 'circle', 'square', 'triangle', 'cross'];

        if (this.Shape === "circle")
        {
            return "fa fa-circle";
        }
        else if (this.Shape === "triangle")
        {
            return "fa fa-play fa-rotate-270";
        }
        else if (this.Shape === "square")
        {
            return "fa fa-square";
        }
        else if (this.Shape === "cross")
        {
            return "fa fa-times";
        }

        return null;
    }

    constructor(rm: AlternativeStatusReadModel)
    {
        this.Name = rm.Name;
        this.Id = rm.Id;
    }
}


class AlternativesGroup
{
    Name: string;
    Label: string;
    Color: string;
    BgColor: string;

    constructor(name: string, color: string, bgColor: string)
    {
        this.Name = name;
        this.Label = isNullOrWhitespace(this.Name) ? "[not set]" : this.Name;
        this.Color = color;
        this.BgColor = bgColor;
    }
}

class FieldId
{
    static Id = `tchAlternativeId`;
    static AlternativeId = `tchAlternativeAlternativeId`;
    static AlternativeName = `tchAlternativeName`;
    static AlternativeDescription = `tchAlternativeDescription`;
    static AlternativeCreated = `tchAlternativeCreated`;
    static AlternativeModified = `tchAlternativeModified`;
    static AlternativeStatusName = `tchAlternativeStatusName`;
    static AlternativeStartDate: string = "$tchAlternativeStartDate";
    static AlternativeCommitmentDate: string = "$tchAlternativeCommitmentDate";

    static Attribute(attrId: number): string { return `tchAttributeName${attrId}`; }
}

class BubbleAnalysis
{
    static CreateChartData(
        alternativesView: AlternativeViewModel[],
        xAxisOption: { Label: string, Value: string },
        yAxisOption: { Label: string, Value: string },
        zAxisOption: { Label: string, Value: string }): BubblePoint[]
    {
        const xAxisValues = BubbleAnalysis.GetAxisValues(alternativesView, xAxisOption, [], []);
        const yAxisValues = BubbleAnalysis.GetAxisValues(alternativesView, yAxisOption, [], []);
        const zAxisValues = BubbleAnalysis.GetAxisValues(alternativesView, zAxisOption, xAxisValues, yAxisValues);

        const bubbles: BubblePoint[] = alternativesView.map(a =>
        {
            const bubble = new BubblePoint();
            bubble.Color = a.Color;
            bubble.Name = a.Name;
            bubble.AlternativeId = a.AlternativeId;
            bubble.X = xAxisValues.find(v => v.AlternativeId === a.AlternativeId)?.Value || 0;
            bubble.Y = yAxisValues.find(v => v.AlternativeId === a.AlternativeId)?.Value || 0;
            bubble.Size = zAxisValues.find(v => v.AlternativeId === a.AlternativeId)?.Value || 0;
            return bubble;
        });

        return bubbles;
    }

    private static GetAxisValues(
        alternativesView: AlternativeViewModel[],
        axisOption: { Label: string, Value: string },
        xAxisValues: { AlternativeId: number, Value: number }[],
        yAxisValues: { AlternativeId: number, Value: number }[]): { AlternativeId: number, Value: number }[]
    {
        const axisAttributeId: number = axisOption.Value.startsWith("attribute") ? parseInt(axisOption.Value.replace("attribute", "")) : null;

        const data: { AlternativeId: number, Value: number }[] = [];

        if (axisAttributeId != null)
        {
            alternativesView.forEach(alternative =>
            {
                alternative.AttributeValues.filter(av => av.AttributeId === axisAttributeId).forEach(av =>
                {
                    data.push({ AlternativeId: alternative.AlternativeId, Value: av.HasValue ? Number(av.Value) : null });
                });
            });
        }
        else
        {
            if (axisOption.Value === "equal")
            {
                alternativesView.forEach(alternative =>
                {
                    data.push({ AlternativeId: alternative.AlternativeId, Value: 1 });
                });
            }
            else if (axisOption.Value === "ratioXY")
            {
                alternativesView.forEach(alternative =>
                {
                    const xValue = xAxisValues.find(av => av.AlternativeId === alternative.AlternativeId)?.Value || 0;
                    const yValue = yAxisValues.find(av => av.AlternativeId === alternative.AlternativeId)?.Value || 0;

                    if (yValue > 0)
                    {
                        const ratio = xValue / yValue;
                        data.push({ AlternativeId: alternative.AlternativeId, Value: ratio });
                    }
                });
            }
            else if (axisOption.Value === "ratioYX")
            {
                alternativesView.forEach(alternative =>
                {
                    const xValue = xAxisValues.find(av => av.AlternativeId === alternative.AlternativeId)?.Value || 0;
                    const yValue = yAxisValues.find(av => av.AlternativeId === alternative.AlternativeId)?.Value || 0;

                    if (xValue > 0)
                    {
                        const ratio = yValue / xValue;
                        data.push({ AlternativeId: alternative.AlternativeId, Value: ratio });
                    }
                });
            }
        }

        return data;
    }
}

class BubblePoint
{
    AlternativeId: number;
    Name: string;
    X: number;
    Y: number;
    Size: number;
    Color: string;
}


class AlternativesUtils
{


    static processAttributeValues(attr: AttributeReadModel, attrValues: AlternativeAttributeValueReadModel[])
    {
        const values = attrValues
            .filter(a => a.AttributeId === attr.Id)
            .map(a => AttributeUtils.convertUnknownValue(attr, a.Value))
            .filter(a => a != null);

        if (values.length === 0)
        {
            return null;
        }

        if (values.length === 1)
        {
            return values[0];
        }

        if (attr.IsList)
        {
            return values.map(val => attr.DefinedValues.find(dv => dv.Value === val)?.Name ?? val).join("; ");
        }

        return values.join("; ");
    }

    static parseValue(attribute: AttributeReadModel, strVal: string | null): string | number | Date | null
    {
        if (strVal == null) return null;

        let val: string | number | Date = strVal; // Assume string initially

        if (attribute.IsNumeric)
        {
            //val = Number.parseFloat(strVal);
            return Number.parseFloat(strVal);
        }
        else if (attribute.IsDate)
        {
            val = new Date(strVal);
        }

        // After converting to the appropriate type, check if it's a list and find the item
        if (attribute.IsList)
        {
            return attribute.DefinedValues.find(dv => dv.Value.toString() === val.toString())?.Name ?? val;
        }

        return val; // Return converted value if not a list or the list item if it is
    }
}